
import { Component, Vue, Prop } from 'vue-property-decorator';
import { checkLogin } from '@/utils/tools';
@Component
export default class CommonRankFollow extends Vue {
  @Prop() private status!: boolean;
  handleFollow() {
    checkLogin(
      () => {
        this.$emit('follow');
      },
      () => {
        this.$syncFollow();
      }
    );
  }
}
